import { apiFetch } from '../../core/api.js';
import { aiChatMessagesEl, aiChatInputEl, aiChatSendBtn } from './dom.js';
import {
  getAiChatSending,
  setAiChatSending,
  pushAiChatHistoryMessage,
  popAiChatHistoryMessage,
  getAiChatHistory
} from './session.js';
import { sanitizeAiChatReplyText } from './markdown.js';
import { cancelAiChatTextStream } from './stream.js';
import { appendAiChatBubble } from './messages.js';
import type { AiChatApiResponse } from '../../types/api.js';

export async function sendAiChatMessage(): Promise<void> {
  if (getAiChatSending() || !aiChatInputEl) return;
  const text = String(aiChatInputEl.value || '').trim();
  if (!text) return;
  cancelAiChatTextStream();
  setAiChatSending(true);
  if (aiChatSendBtn) aiChatSendBtn.disabled = true;
  aiChatInputEl.value = '';
  appendAiChatBubble('user', text, { sendIn: true });
  pushAiChatHistoryMessage({ role: 'user', content: text });
  const loadingRow = appendAiChatBubble('assistant', '', { loading: true, incoming: true, fadeOnly: true });
  try {
    const res = await apiFetch('/api/ai/chat', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        messages: getAiChatHistory(),
        uiWelcomeShown: !!(aiChatMessagesEl && aiChatMessagesEl.querySelector('.chat-msg-row-them'))
      })
    });
    const data = (await res.json().catch(function () {
      return {};
    })) as AiChatApiResponse;
    if (loadingRow && loadingRow.parentNode) loadingRow.parentNode.removeChild(loadingRow);
    if (!res.ok || !data.ok || !data.reply) {
      const errText =
        (data && data.error) ||
        (res.status === 503 ? 'ИИ-помощник пока не настроен на сервере.' : 'Не удалось получить ответ.');
      const errRow = appendAiChatBubble('assistant', errText, { incoming: true, streamText: true });
      if (errRow && errRow._aiStreamPromise) await errRow._aiStreamPromise;
      popAiChatHistoryMessage();
      return;
    }
    const replyText = sanitizeAiChatReplyText(data.reply);
    pushAiChatHistoryMessage({ role: 'assistant', content: replyText });
    const replyRow = appendAiChatBubble('assistant', replyText, { incoming: true, streamText: true });
    if (replyRow && replyRow._aiStreamPromise) await replyRow._aiStreamPromise;
  } catch (_) {
    if (loadingRow && loadingRow.parentNode) loadingRow.parentNode.removeChild(loadingRow);
    const failRow = appendAiChatBubble('assistant', 'Нет связи с сервером. Проверьте интернет и попробуйте снова.', {
      incoming: true,
      streamText: true
    });
    if (failRow && failRow._aiStreamPromise) await failRow._aiStreamPromise;
    popAiChatHistoryMessage();
  } finally {
    setAiChatSending(false);
    if (aiChatSendBtn) aiChatSendBtn.disabled = false;
    if (aiChatInputEl) {
      try {
        aiChatInputEl.focus();
      } catch (_) {}
    }
  }
}
